import { Navigate, useLocation } from "react-router-dom";
import { useResident } from "../../context/ResidentAuth";

export default function RequireResident({ children }) {
  const { resident, ready } = useResident();
  const loc = useLocation();
  if (!ready) return <div className="py-32 text-center text-muted-foreground" data-testid="auth-loading">Yükleniyor...</div>;
  if (!resident) return <Navigate to="/giris" replace state={{ from: loc.pathname + loc.search }} />;
  return children;
}
